"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wallet = void 0;
const axios_class_1 = require("./axios.class");
class Wallet {
    isOwaltAddress(address) {
        return axios_class_1.axios.get(`wallets/isOwaltAddress/${address}`);
    }
}
exports.wallet = new Wallet();
